@if (getPermission('UsersGrid_serviceUsersTab')?.visible || getPermission('UsersGrid_salesUsersTab')?.visible) {
<div class="w-100 users-page">
  <div class="border p-2 pt-3">
    <div class="row mb-2">
      <div class="col">
        <div class="tabbable-line border-bottom">
          <ul class="nav nav-tabs">
            @if (getPermission('UsersGrid_serviceUsersTab')?.visible) {
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': selectedTab === 'service'}" (click)="tabClick('service')">Service</a>
              </li>
            }
            @if (getPermission('UsersGrid_salesUsersTab')?.visible) {
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': selectedTab === 'sales'}" (click)="tabClick('sales')">Sales</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
  @if (gridConfig) {
  <div #gridPage class="users-grid" [style.height.px]="gridPageHeight()">
    <inavista-grid #usersGrid
      [config]="gridConfig"
      [actionIcons]="actionIcons"
      (actionIconClick)="onActionIconClick($event)"
      (hyperlinkClick)="onHyperlinkClick($event)"
      (toolbarActionClick)="onToolbarAction($event)" />
  </div>
  }
</div>
}

@if (showUserProfilePopup) {
  <app-user-profile-popup
  [userProfile]="userProfile"
  (closePopup)="onClosePopup()"
  ></app-user-profile-popup>
}

<!-- Primary territory / district / region, with the old icon when the user also has secondary ones (their names in the tooltip). -->
<ng-template #territoryCell let-row>
  @if (row?.secondaryTerritories) {
    <i class="fas fa-diagram-project green me-1" [title]="'Secondary Territories: ' + row.secondaryTerritories"></i>
  }
  {{ row?.territory }}
</ng-template>
<ng-template #districtCell let-row>
  @if (row?.secondaryDistricts) {
    <i class="fas fa-diagram-project green me-1" [title]="'Secondary Districts: ' + row.secondaryDistricts"></i>
  }
  {{ row?.district }}
</ng-template>
<ng-template #regionCell let-row>
  @if (row?.secondaryRegions) {
    <i class="fas fa-diagram-project green me-1" [title]="'Secondary Regions: ' + row.secondaryRegions"></i>
  }
  {{ row?.region }}
</ng-template>
